import classNames from 'classnames';
import { forwardRef } from 'react';

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    /**
     * Какой тег рендерить
     */
    tag?: keyof JSX.IntrinsicElements;
    /**
     * Цветовая тема кнопки
     */
    variant?: 'white' | 'primary' | 'white-outline';
}

const RoundButton = forwardRef<HTMLButtonElement, Props>(
    ({ tag = 'button', variant = 'primary', children, ...props }, ref) => {
        const Component = tag as any;

        return (
            <Component {...props} className={classNames(`round-btn round-btn-${variant}`, props.className)}>
                {children}
            </Component>
        );
    },
);

RoundButton.displayName = 'RoundButton';

export default RoundButton;
